__turbopack_context__.v({
  "add-field-btn": "Card-module-scss-module__F55F9a__add-field-btn",
  "add-field-btn-container": "Card-module-scss-module__F55F9a__add-field-btn-container",
  "base-lock": "Card-module-scss-module__F55F9a__base-lock",
  "card": "Card-module-scss-module__F55F9a__card",
  "card-body": "Card-module-scss-module__F55F9a__card-body",
  "card-container": "Card-module-scss-module__F55F9a__card-container",
  "card-edit-section-header": "Card-module-scss-module__F55F9a__card-edit-section-header",
  "card-edit-section-label-and-lock": "Card-module-scss-module__F55F9a__card-edit-section-label-and-lock",
  "card-edit-subsection": "Card-module-scss-module__F55F9a__card-edit-subsection",
  "card-field": "Card-module-scss-module__F55F9a__card-field",
  "card-field-btn": "Card-module-scss-module__F55F9a__card-field-btn",
  "card-field-outline": "Card-module-scss-module__F55F9a__card-field-outline",
  "card-item": "Card-module-scss-module__F55F9a__card-item",
  "card-item-icon-circle": "Card-module-scss-module__F55F9a__card-item-icon-circle",
  "card-items": "Card-module-scss-module__F55F9a__card-items",
  "card-measurer": "Card-module-scss-module__F55F9a__card-measurer",
  "delete-field-btns": "Card-module-scss-module__F55F9a__delete-field-btns",
  "delete-field-warning": "Card-module-scss-module__F55F9a__delete-field-warning",
  "delete-field-warning-heading": "Card-module-scss-module__F55F9a__delete-field-warning-heading",
  "edit-card-field-popover-btns": "Card-module-scss-module__F55F9a__edit-card-field-popover-btns",
  "edit-card-field-popover-save-cancel-btns": "Card-module-scss-module__F55F9a__edit-card-field-popover-save-cancel-btns",
  "edit-icon": "Card-module-scss-module__F55F9a__edit-icon",
  "extra-information-icon": "Card-module-scss-module__F55F9a__extra-information-icon",
  "extra-information-icon-circle": "Card-module-scss-module__F55F9a__extra-information-icon-circle",
  "extra-information-item": "Card-module-scss-module__F55F9a__extra-information-item",
  "extra-information-list": "Card-module-scss-module__F55F9a__extra-information-list",
  "extra-information-value": "Card-module-scss-module__F55F9a__extra-information-value",
  "lock": "Card-module-scss-module__F55F9a__lock" + " " + "Card-module-scss-module__F55F9a__base-lock",
  "lock-all-fields-btn": "Card-module-scss-module__F55F9a__lock-all-fields-btn",
  "lock-icon": "Card-module-scss-module__F55F9a__lock-icon",
  "lock-message-fade-in": "Card-module-scss-module__F55F9a__lock-message-fade-in",
  "notification-icon": "Card-module-scss-module__F55F9a__notification-icon",
  "save-btn-container": "Card-module-scss-module__F55F9a__save-btn-container",
  "save-btn-sentinel": "Card-module-scss-module__F55F9a__save-btn-sentinel",
  "user-details": "Card-module-scss-module__F55F9a__user-details",
  "user-name": "Card-module-scss-module__F55F9a__user-name",
  "user-name-container": "Card-module-scss-module__F55F9a__user-name-container",
  "user-pronouns": "Card-module-scss-module__F55F9a__user-pronouns",
});
